module.exports = __webpack_public_path__ + "static/img/12.8091cd3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/eng/12.png
// module id = giPO
// module chunks = 0